import {
  ORDER_PRODUCT_ROW_GUTTER,
  ORDER_PRODUCT_STACKED_MIN_WIDTH,
  ORDER_PRODUCT_WIDE_MIN_WIDTH,
} from './orderProductsLayout.constants';
import {
  OrderProductRowGutter,
  OrderProductRowLayout,
  ResolveOrderProductRowLayoutParams,
} from './orderProductsLayout.types';

export const resolveOrderProductRowLayout = ({
  containerWidth,
  isMobileViewport,
  isTabletViewport,
}: ResolveOrderProductRowLayoutParams): OrderProductRowLayout => {
  if (isMobileViewport) {
    return OrderProductRowLayout.MOBILE;
  }

  if (isTabletViewport) {
    return containerWidth >= ORDER_PRODUCT_STACKED_MIN_WIDTH
      ? OrderProductRowLayout.STACKED
      : OrderProductRowLayout.MOBILE;
  }

  return containerWidth >= ORDER_PRODUCT_WIDE_MIN_WIDTH
    ? OrderProductRowLayout.WIDE
    : OrderProductRowLayout.CONDENSED;
};

export const isOrderProductRowInline = (layout: OrderProductRowLayout) =>
  layout === OrderProductRowLayout.WIDE;

export const getOrderProductRowGutter = (layout: OrderProductRowLayout): OrderProductRowGutter =>
  ORDER_PRODUCT_ROW_GUTTER[layout];
